import { HttpClient } from '../../shared/http-client';
import 'rxjs/add/operator/map';
var KairosService = /** @class */ (function () {
    function KairosService(httpClient) {
        this.httpClient = httpClient;
    }
    KairosService.prototype.guardar = function (kairos) {
        var postData = { nombre: kairos.nombre, tipo: kairos.tipo };
        return this.httpClient.postWithFile('/kairos/', postData, { file: kairos.archivo, name: 'archivo' });
    };
    KairosService.prototype.listado = function (pagina, cantidadPorPagina) {
        // get users from api
        return this.httpClient.get("/kairos/?pagina=" + pagina + "&cantidadPorPagina=" + cantidadPorPagina)
            .map(function (response) {
            return response.json();
        });
    };
    KairosService.prototype.eliminar = function (id) {
        return this.httpClient.delete("/kairos/" + id);
    };
    KairosService.ctorParameters = function () { return [{ type: HttpClient }]; };
    return KairosService;
}());
export { KairosService };
//# sourceMappingURL=kairos.service.js.map


// WEBPACK FOOTER //
// kairos.service.js